<template>
  <lazy-image
    v-if="!getIsMobile"
    :src="desktop_src"
    :lazy_src="desktop_src_lazy"
    :alt="alt_images"
    :cover_img="cover_img"
  />
  <div v-else
       class="shape-head-image-component">
    <lazy-image
      :src="String(get_mobile_src)"
      :lazy_src="mobile_src_lazy"
      :alt="alt_images"
      :cover_img="cover_img"
    />
    <semicircle-icon
      v-if="!hide_shape"
      class="shape-head-image-component_fill"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import LazyImage from "../small_parts/LazyImage.vue";
import SemicircleIcon from "../fill_svg/SemicircleIcon.vue";

export default {
  name: 'ShapeHeadImageComponent',
  components: {
    SemicircleIcon,
    LazyImage
  },
  props: {
    desktop_src: {
      type: String,
      required: true
    },
    desktop_src_lazy: {
      type: String,
      default: ''
    },
    mobile_src: {
      type: String,
      default: ''
    },
    mobile_src_lazy: {
      type: String,
      default: ''
    },
    alt_images: {
      type: String,
      default: 'slide image'
    },
    cover_img: {
      type: Boolean,
      default: false
    },
    hide_shape: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    get_mobile_src() {
      return this.mobile_src
        ? this.mobile_src
        : (!this.desktop_src_lazy && this.desktop_src) ? this.desktop_src : this.desktop_src_lazy
    }
  },
}
</script>
